import script from "./select-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./select-item.vue?vue&type=script&setup=true&lang=ts"

import "./select-item.vue?vue&type=style&index=0&id=3b81e1ea&lang=scss"

const __exports__ = script;

export default __exports__